<!-- 全局校区 -->
<template>
  <div v-show="compVisible">
    <el-popover
      placement="bottom-start"
      trigger="click"
      :show-arrow="false"
      :width="300"
      :teleported="false"
      v-model:visible="popShow"
      popper-class="campus-popper"
      @show="resetCampus"
      @after-leave="resetCampus"
    >
      <template #reference>
        <div class="campus-button" @click="popShow = !popShow">
          <div class="name">{{ globalName }}</div>
          <span class="link">{{ multiple ? '选择' : '切换' }}</span>
        </div>
      </template>
      <div class="campus-container-box" :class="{ multiple: multiple }" v-click-outside="reset">
        <div class="search-box">
          <el-input placeholder="请输入校区名称" v-model="keyword" clearable>
            <template #prefix>
              <i class="el-icon-search"></i>
            </template>
          </el-input>
        </div>
        <el-scrollbar wrap-class="campus-list">
          <!-- 单选 -->
          <template v-if="!multiple">
            <div
              class="campus-item"
              :class="{ active: curCampus[0] === item.id }"
              v-for="item in tempCampusList"
              :key="item.id"
              :value="item.id"
              @click="choose(item.id)"
            >
              {{ item.name }}
            </div>
          </template>
          <!-- 多选 -->
          <template v-else>
            <el-checkbox-group v-model="curCampus">
              <div class="campus-item" v-for="item in tempCampusList" :key="item.id" :value="item.id">
                <el-checkbox :label="item.id">{{ item.name }}</el-checkbox>
              </div>
            </el-checkbox-group>
            <div class="footer">
              <el-checkbox v-model="selectAll">全选</el-checkbox>
              <div>
                <el-button type="default" @click="reset">取消</el-button>
                <el-button type="primary" @click="changeCampus">确定</el-button>
              </div>
            </div>
          </template>
        </el-scrollbar>
      </div>
    </el-popover>
  </div>
</template>

<script>
import {
  computed, inject, ref, watch, reactive,
} from 'vue';
import { useRoute } from 'vue-router';
import { ClickOutside } from 'element-plus';

export const campus = reactive([]);
function setCampus(list) {
  campus.length = 0;
  campus.push(...list);
}

const compVisible = ref(false);

export function showGlobalCampus(val) {
  compVisible.value = Boolean(val);
}

export default {
  directives: {
    ClickOutside,
  },
  setup() {
    // 校区切换
    const keyword = ref('');
    const { globalCampusList, user } = inject('store');
    const tempCampusList = computed(() => {
      // eslint-disable-next-line no-unused-expressions
      [globalCampusList.value, keyword.value];
      return globalCampusList.value.filter((item) => item.name.indexOf(keyword.value) > -1);
    });

    // 记录最近一个单选校区
    let singleRecord = [];
    const curCampus = ref([]);
    // 初始化默认校区,或者上次勾选的校区.
    watch(
      () => user.value.defaultCampusId,
      (id) => {
        if (id) {
          curCampus.value = [id];
          setCampus([id]);
          singleRecord = [id];
        }
      },
      {
        immediate: true,
      },
    );

    const route = useRoute();

    const multiple = computed(() => route.meta.globalCampus === 'multiple');
    const popShow = ref(false);
    // 切换路由时, 重置并初始化校区的显示和状态.
    watch(
      () => route.path,
      () => {
        popShow.value = false;
        const { globalCampus } = route.meta;
        if (globalCampus === 'multiple') {
          singleRecord = [...campus];
        } else if (globalCampus) {
          setCampus(singleRecord);
        }
        compVisible.value = Boolean(route.meta?.globalCampus && tempCampusList.value.length);
      },
      {
        immediate: true,
      },
    );

    function resetCampus() {
      curCampus.value = [...campus];
    }

    function changeCampus() {
      const sort = (a, b) => a - b;
      const idsPrev = [...campus].sort(sort).join('-');
      const idsNow = curCampus.value.sort(sort).join('-');
      if (idsPrev !== idsNow) {
        setCampus(curCampus.value);
      }
      popShow.value = false;
      keyword.value = '';
    }

    function choose(id) {
      curCampus.value = [id];
      changeCampus();
    }

    const globalName = computed(() => {
      // eslint-disable-next-line no-unused-expressions
      [tempCampusList.value, multiple.value, campus];
      if (multiple.value && campus.length > 1) {
        return `${campus.length}个校区`;
      }
      return tempCampusList.value.find((item) => item.id === campus[0])?.name;
    });

    const selectAll = computed({
      get: () => curCampus.value.length === globalCampusList.value.length,
      set: (value) => {
        if (!value) {
          curCampus.value = [];
        } else {
          curCampus.value = tempCampusList.value.map((item) => item.id);
        }
      },
    });

    return {
      tempCampusList,
      curCampus,
      compVisible,
      multiple,
      changeCampus,
      keyword,
      popShow,
      resetCampus,
      choose,
      globalName,
      selectAll,
      reset() {
        popShow.value = false;
        curCampus.value = [...campus];
      },
    };
  },
};
</script>

<style lang="scss">
.campus-button {
  height: 32px;
  // background: var(--g9);
  background: var(--white);
  color: var(--g1);
  display: flex;
  font-size: var(--fs-md);
  line-height: 32px;
  justify-content: center;
  align-content: center;
  padding: 0 16px;
  border-radius: 16px;
  cursor: pointer;
  background: #f0f2f5;
  &:hover {
    background: #f0f2f5;
  }
  .name {
    max-width: 150px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .link {
    color: var(--primary);
    margin-left: 8px;
  }
}

.campus-popper {
  width: 300px;
  padding: 0 !important;
  cursor: pointer;
  .campus-container-box {
    width: 100%;
    height: 100%;
    background: var(--white);
    .search-box {
      margin: 16px 16px 12px;
    }
    &.multiple {
      .campus-list {
        min-height: 0;
      }
    }
    .campus-list {
      font-size: 14px;
      max-height: 500px;
      min-height: 120px;
      .campus-item {
        height: 38px;
        line-height: 38px;
        padding-left: 16px;
        &:hover {
          background: var(--g9);
        }
        &.active {
          color: #1989fa;
        }
      }
    }
    .footer {
      height: 60px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 16px;
      background: var(--g9);
      box-shadow: 0px 1px 0px 0px var(--g5);
    }
  }
}
</style>
